import React from 'react'
import './Table.scss'

export default function Table(props) {
  const {
    slice
  } = props


  const header = Object.keys(slice.primary).filter(item => !item.includes('lysing'))
  const lysing = Object.keys(slice.primary).filter(item => item.includes('lysing'))

  return (
    
    <table style={{margin:'60px auto 0', overflowX: 'auto', width: '100%' }} className='table'>
      <tr>
        <React.Fragment>
          {header.map((head, index) => {
            const test = slice.primary[head][0]
            const test2 = slice.primary[lysing[index]][0]
            let myHeader = null
            let myLysing = null
            if (test) {
              myHeader = test.text
            }

            if (test2) {
              myLysing = test2.text
            }
            return (
              <th >
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
                  <React.Fragment>
                    <p className='table__header'>{myHeader}</p>
                    <p className='table__lysing'>{myLysing}</p>
                  </React.Fragment>
                </div>
              </th>
            );
          })}
        </React.Fragment>
      </tr>
      {slice.items.map((item, index) => (
        <tr>
          {Object.keys(item).map((i, index) => {
            const check = item[i][0]
            if (check) {
              return (
                <td>
                  {check.text}
                </td>
              )
            } else return <td></td>
          })}
        </tr>
      ))}
    </table>

  )
}